module.exports = __webpack_public_path__ + "img/5.f8fe3605.png";